// Axios API service with baseURL from environment and auth header attachment
import axios from 'axios'
const API_URL = import.meta.env.VITE_API_URL || 'https://riderfieldmotors.in/api/'

export const api = axios.create({
  baseURL: API_URL,
  timeout: 60000
})

// Attach Authorization header if a token exists in localStorage
api.interceptors.request.use((config) => {
  const raw = localStorage.getItem('auth')
  if (raw) {
    try {
      const { token } = JSON.parse(raw)
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } catch (_) { /* ignore parse errors */ }
  }
  return config
})

export default {
  async login(email, password, role) {
    // POST /api/login with provided credentials
    const { data } = await api.post('login', { email, password, role })
    return data
  }
}
